import styled from 'styled-components';

import colors from '@theme/colors';

export const TermsText = styled.p`
  color: ${({ dark }) => (dark ? colors['beige'] : colors['charcoal'])};
  font-size: 14px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  margin: 0;
  margin-top: 10px;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
